import { atBqnTarget } from "common/api";

export const BOXPLOT_METRICS_SET = new Set([
  "MEAN-Mbps",
  "SUBS-ACTIVE",
  "RTT-80%-ms",
  "RTT-MED-ms",
  "RTT-MIN-ms",
  "RTX",
  "CONGEST",
]);

export function getParsedDataSubs(rows, headerMap, subsGroups, subsTypes) {
  const subGroupsSet = new Set(subsGroups);
  const parsedData = rows.reduce(
    (acc, row, indexRow) => {
      const [nameGroup, ...attrs] = row.split(/\s+/);
      if (nameGroup && subGroupsSet.has(nameGroup)) {
        acc.names.push(nameGroup);
        const item = [nameGroup, ...attrs].reduce(
          (accItem, attr, index) => {
            const attrName = headerMap[index];
            accItem[attrName] = attr;
            if (nameGroup !== "all-subscribers") {
              if (BOXPLOT_METRICS_SET.has(attrName)) {
                if (acc[attrName]) {
                  acc[attrName].push(attr);
                } else {
                  acc[attrName] = [attr];
                }
              }
            }
            return accItem;
          },
          { "GROUP-TYPE": subsTypes[nameGroup], id: indexRow }
        );
        acc.totalGroups += 1;
        acc.newRows.push(item);
      }

      return acc;
    },
    { newRows: [], names: [], totalGroups: 0 }
  );

  return parsedData;
}


// The type of each subscriber group of the BQN given, which a caller that
// asks for the command on its own, or with others in a batch, parses with it.
export const parseSubscriberGroupTypeMap = (response, bqnId) => {
  let [header, ...rows] = response.trim().split("\n");

  if (bqnId !== "all") {
    rows = rows.filter((row) => row.trim().startsWith(bqnId.toString()));
  }

  const headerAttrs = header.split(/\s+/);
  const subscriberNameId = headerAttrs.findIndex(
    (el) => el === "SUBSCRIBER-GROUP",
  );
  const subscriberTypeId = headerAttrs.findIndex((el) => el === "GROUP-TYPE");

  return rows.reduce((acc, row) => {
    const rowAttrs = row.trim().split(/\s+/);
    acc[rowAttrs[subscriberNameId]] = rowAttrs[subscriberTypeId];
    return acc;
  }, {});
};

export const getSubscriberGroupTypeMap = (ifCl, bqnId, mode) =>
  ifCl
    .run(atBqnTarget("show api subscriber-group", mode, bqnId))
    .then((response) => parseSubscriberGroupTypeMap(response, bqnId));
